import React from "react";
import "../../styles/ReportFilterBar.css";

const ReportFilterBar = ({ filter, setFilter }) => {

    return (

        <div className="report-filter">

            <select
                value={filter}
                onChange={(e) =>
                    setFilter(e.target.value)
                }
            >

                <option value="today">
                    Today
                </option>

                <option value="7days">
                    Last 7 Days
                </option>

                <option value="30days">
                    Last 30 Days
                </option>

                <option value="month">
                    This Month
                </option>

                <option value="year">
                    This Year
                </option>

            </select>

        </div>

    );

};

export default ReportFilterBar;